export const chat_bot_parameter_style = {
  inputGroupSx: { display: 'grid', gap: 0.5 },
  labelSx: {
    color: 'text.label',
  },
  inputFieldSx: {
    marginTop: '4px',
  },
};
